import { render } from "./lessonAdd.vue?vue&type=template&id=bcc1623e&scoped=true"
import script from "./lessonAdd.vue?vue&type=script&lang=js"
export * from "./lessonAdd.vue?vue&type=script&lang=js"

import "./lessonAdd.vue?vue&type=style&index=0&id=bcc1623e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc1623e"]])

export default __exports__